import { render } from "./ConsultationMedicalHistoryPage.vue?vue&type=template&id=667b031f"
import script from "./ConsultationMedicalHistoryPage.vue?vue&type=script&lang=js"
export * from "./ConsultationMedicalHistoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__